import { alpha, Theme } from '@mui/material'

export const strikePopoverAnchorProps = {
    anchorOrigin: {
        vertical: 'top' as const,
        horizontal: 'right' as const,
    },
    transformOrigin: {
        vertical: 'top' as const,
        horizontal: 'left' as const,
    },
}

export const strikePopoverInteractionProps = {
    hideBackdrop: true,
    disableScrollLock: true,
    disableEnforceFocus: true,
    disableAutoFocus: true,
    disableRestoreFocus: true,
}

export const getStrikePopoverSurfaceBg = (theme: Theme) =>
    theme.palette.mode === 'dark' ? '#141414' : theme.palette.background.paper

export const getStrikePopoverSurfaceSx = (theme: Theme) => ({
    backgroundColor: getStrikePopoverSurfaceBg(theme),
    borderRadius: '8px',
    ...(theme.palette.mode === 'light' && {
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.08)',
    }),
})

export const getStrikePopoverPaperSx = () => ({
    pointerEvents: 'none',
    '.MuiPaper-root': {
        overflow: 'visible',
        backgroundColor: 'transparent',
        boxShadow: 'none',
        pointerEvents: 'auto',
    },
    left: '10px',
})

export const getAtmStrikeTextSx = (theme: Theme) => {
    const outline = alpha(theme.palette.text.secondary, 0.45)
    return {
        border: `1px solid ${outline}`,
        color: outline,
        fontWeight: 500,
    }
}

export const getStrikeTextHighlightSx = (theme: Theme, isActive: boolean) => ({
    backgroundColor: isActive ? theme.palette.primary.main : 'transparent',
    color: isActive ? theme.palette.primary.contrastText : 'inherit',
    fontWeight: isActive ? 500 : 'inherit',
    '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        fontWeight: 500,
    },
})
